import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Typography,
  Button,
  Snackbar,
} from "@material-ui/core";
import clsx from "clsx";
import SelectField from "components/inputs/SelectField";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import { productSize, productQuantity } from "config/var/user";
import { asPrice } from "utils/text";

export default function ProductInfo({
  product,
  productType,
  size,
  productVariantDetails,
  setSize,
  setProductVariantDetails,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  let productSizeOptions = [];
  if (product?.variants?.length > 0) {
    productSizeOptions = product.variants.map((variantFromApi) => {
      let productSizeOptions_ = [];
      productSize.map((variantFromLocal) => {
        if (variantFromApi.variant*1 === variantFromLocal.value*1) {
          productSizeOptions_ = {
            value: variantFromLocal.value,
            key: variantFromLocal.value,
            label: variantFromLocal.label,
            disabled: false,
            selected: false,
          }
        }
      })
      return productSizeOptions_;
    });
  }

  const handleAddCart = () => {
    if (!size) {
      setErrorMessage(`Please select size`);
      return;
    } else if (!qty) {
      setErrorMessage(`Please select quantity`);
      return;
    } else {
      dispatch({
        type: "cart.ADD_PRODUCT",
        payload: {
          product: {
            ...product,
            id: productVariantDetails.id,
            price: productVariantDetails.price,
            image: productVariantDetails?.image,
          },
          count: qty,
          size: size,
          productType,
          sizeValue: sizeValue,
        },
      });
    }
  };
  const [qty, setQty] = useState(1);
  // const [size, setSize] = useState(null);
  const [sizeValue, setSizeValue] = useState(null);
  const setupQty = (value) => {
    if (qty == 0) {
      setQty(parseInt(value));
    } else {
      setQty(parseInt(value));
    }
  };
  return (
    <div className={`${classes.root} product-list`}>
      <div className={`${classes.itemInfos} item-infos`}>
        <div class="item-img">
          <h6 className={classes.title}>{product?.title}</h6>
        </div>
        <strong className={classes.itemPrice}>{asPrice(productVariantDetails?.price ? productVariantDetails.price : 0)}</strong>
        <div className={classes.descriptionMain}>
          <Typography
            className={classes.description}
            dangerouslySetInnerHTML={{
              __html: productVariantDetails?.description,
            }}
          />
        </div>
        <label className={classes.label}>Select Size</label>

        <div className={clsx(classes.sortRoot, classes.selectMain)}>
          <SelectField
            value={size}
            onChange={(e) => {
              setSize(e.target.value);
              product &&
                product.variants?.map((ol) => {
                  if (e.target.value == ol.variant) {
                    setProductVariantDetails(ol);
                  }
                });

              var index = e.target.selectedIndex;
              setSizeValue(e.target[index].text);
            }}
            className={clsx(classes.select, classes.input)}
            options={[
              { label: "Please Select Size", value: "", key: "", selected: true },
              ...productSizeOptions,
            ]}
          />
        </div>
        <label className={classes.label}>QTY</label>

        <div className={clsx(classes.sortRoot, classes.selectMain)}>
          <SelectField
            onChange={(e) => {
              setupQty(e.target.value);
            }}
            className={clsx(classes.select, classes.input)}
            options={[...productQuantity]}
          />
        </div>
      </div>
      {product ? (
        <Button
          variant="contained"
          color="primary"
          className={classes.btn}
          onClick={() => {
            handleAddCart();
          }}
        >
          Add to Cart
        </Button>
      ) : (
        <Button variant="contained" color="primary" className={classes.btn}>
          &nbsp;
        </Button>
      )}
      <Snackbar
        open={errorMessage}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        onClose={(e, r) => {
          if (r == "timeout") setErrorMessage("");
        }}
      >
        <Alert
          severity="error"
          variant="filled"
          onClose={() => setErrorMessage("")}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  itemInfos: {
    width: "80%",
  },
  selectMain: {
    marginBottom: 15,
    marginTop: 5,
  },
  price: {
    marginTop: 6,
    marginBottom: 13,
    fontSize: 18,
    fontWeight: 500,
  },
  descriptionMain: {
    marginBottom: 15,
  },
  memberPrice: {
    color: theme.palette.text.disabled,
    fontSize: 14,
  },
  btn: {
    width: "80%",
    fontSize: 14,
    fontWeight: 500,
    textTransform: "capitalize",
    marginTop: 12,
    background: "#05C1FF !important",
    color: "white !important",
  },
  productRoot: {},
  paper: {
    backgroundColor: theme.palette.background.default,
    marginTop: theme.spacing(6),
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: 35,
    marginBottom: 24,
  },
  input: {
    textAlign: "center",
  },
  submitBtn: {
    marginTop: 2,
    marginLeft: theme.spacing(2),
  },
  select: {
    width: "100%",
  },
  sortRoot: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  label: {
    fontSize: 16,
    fontWeight: 600,
    marginRight: 10,
  },
  controls: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    justifyContent: "space-between",
    width: 100,
  },

  controlBtn: {
    background: "#F5F5F5",
    boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.19971)",
    borderRadius: 5,
    width: 24,
    height: 24,
  },
  controlField: {
    width: 30,
    textAlign: "center",
  },
  controlInput: {
    border: 0,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    textAlign: "center",
  },
  inputRoot: {
    paddingLeft: 14,
    paddingRight: 14,
  },
  productDetail: {
    width: "80%",
  },
  title: {
    fontSize: 22,
  },
  description: {
    fontSize: 15,
  },
  itemPrice: {
    color: "#3AC7FF",
  },
}));
